import { SessionStorageKeys } from '@aglenergy/shared-library';
import { store } from 'app/shared/store/store';
import { FlowDetails, FlowType } from 'app/shared/models/flow-details.model';
import { ResponseError } from 'app/shared/models/response-error.error';

export class FlowService {
  public getFlowDetails(): FlowDetails {
    return JSON.parse(sessionStorage.getItem(SessionStorageKeys.FlowDetails)) as FlowDetails;
  }

  public setFlowDetails(flowDetails?: FlowDetails): void {
    if (flowDetails) {
      sessionStorage.setItem(SessionStorageKeys.FlowDetails, JSON.stringify(flowDetails));
    } else {
      sessionStorage.removeItem(SessionStorageKeys.FlowDetails);
    }
  }

  public getLastAdded(): string {
    const flowDetails = this.getFlowDetails();
    return flowDetails?.lastAdded;
  }

  public getActiveCategory(): string {
    const flowDetails = this.getFlowDetails();
    return flowDetails?.activeCategory;
  }

  public setActiveCategory(activeCategory: string): void {
    const flowDetails = this.getFlowDetails();
    if (flowDetails) {
      flowDetails.activeCategory = activeCategory;
      this.setFlowDetails(flowDetails);
    }
  }

  public getFlowError(): ResponseError {
    const flowDetails = this.getFlowDetails();
    return flowDetails?.error;
  }

  public setFlowError(newError: ResponseError): void {
    const flowDetails = this.getFlowDetails();
    if (flowDetails) {
      flowDetails.error = newError;
      this.setFlowDetails(flowDetails);
    }
  }

  public setFlowType(flowType: FlowType): void {
    let flowDetails = this.getFlowDetails();
    if (flowDetails) {
      flowDetails.flowType = flowType;
    } else {
      flowDetails = {
        flowType
      };
    }
    this.setFlowDetails(flowDetails);
  }

  public setAddressRequired(addressRequired: boolean): void {
    const flowDetails = this.getFlowDetails();
    if (flowDetails) {
      flowDetails.addressRequired = addressRequired;
    }
    this.setFlowDetails(flowDetails);
  }

  public getFlowTypeFromStore(): FlowType {
    const isBundle = store.get('isExplicitBundleFlow');
    const isGuidedFlow = store.get('isGuidedFlow');
    const isNbnMovers = store.get('isNbnMovers');
    if (isBundle && isNbnMovers && !isGuidedFlow) {
      return 'movers-bundle-flow';
    } else if (isBundle && !isGuidedFlow) {
      return 'bundle-flow';
    } else if (isGuidedFlow) {
      return 'guided-flow';
    } else if (isNbnMovers) {
      return 'movers-flow';
    }
    return 'default';
  }
}

export const flowService = new FlowService();
